import StockBaseInfo from "../../models/StockBaseInfo";
import { addPortfolio, addPortfolioStock, addPortfolioStockLot, deletePortfolio, deletePortfolioStockLot, importInPortfolio, movePortfolioStock, updatePortfolio, updatePortfolioAmountOfMoney, updatePortfolioStockLot } from "../../services/PortfolioService";

var portfoliosStore = {
    state: () => ({
        portfoliosLoaded: false,
        portfolios: [],
        transactions: [],
        stockObjectives: [],
        positions: [],
        mergedPositions: [],
        portfolioSummary: {},
        dataPackage: {}
    }),

    mutations: {
        UPDATE_PORTFOLIO_INFOS(state, { id, name, description, currency, statistics }) {
            const portfolio = state.portfolios.find(p => p.id === id);
            if (portfolio) {
                portfolio.name = name;
                portfolio.description = description;
                portfolio.currency = currency;
                if (statistics) {
                    portfolio.statistics = statistics;
                }
            }
        },
        SET_PORTFOLIO_SUMMARY(state, { portfolioSummary }) {
            state.portfolioSummary = portfolioSummary;
        },
        SET_DATA_PACKAGE(state, { dataPackage }) {
            state.dataPackage = dataPackage;
        },
        ADD_PORTFOLIO(state, { portfolio }) {
            state.portfolios.push(portfolio);
        },
        DELETE_PORTFOLIO(state, { portfolioId }) {
            state.portfolios = state.portfolios.filter(portfolio => portfolio.id !== portfolioId);
        },
        SET_PORTFOLIOS(state, { portfolios }) {
            state.portfolios = portfolios;
            state.portfoliosLoaded = true;
        },
        SET_TRANSACTIONS(state, { transactions }) {
            state.transactions = transactions;
        },
        ADD_PORTFOLIO_STOCK(state, { portfolioId, stock }) {
            const portfolio = state.portfolios.find(p => p.id === portfolioId)
            portfolio.addStock(stock)
        },

        UPDATE_PORTFOLIO_STOCK_LOT(state, { portfolioId, stockId, lot }) {
            const portfolio = state.portfolios.find(p => p.id === portfolioId)
            const stock = portfolio.stocks.find(s => s.stockId === stockId)
            stock.updateLot(lot)
        },
        REPLACE_PORTFOLIO(state, { portfolio }) {
            state.portfolios = state.portfolios.map(p => {
                if (p.id === portfolio.id) {
                    return portfolio
                }
                return p
            })
        },

        DELETE_PORTFOLIO_STOCK_LOT(state, { updatedPortfolio }) {
            const portfolio = state.portfolios.find(p => p.id === updatedPortfolio.id)
            portfolio.stocks = updatedPortfolio.stocks
        },

        SET_PORTFOLIO_AMOUNT_IN_CASH(state, { portfolioId, amountOfMoney }) {
            const portfolio = state.portfolios.find(p => p.id === portfolioId)
            portfolio.amountOfMoney = amountOfMoney
            portfolio.calculateStatisticsWithMoney()
        },
        SET_STOCK_OBJECTIVES(state, { stockObjectives }) {
            state.stockObjectives = stockObjectives;
        },
        SET_POSITIONS(state, { positions }) {
            state.positions = positions;
        },
        SET_MERGED_POSITIONS(state, { mergedPositions }) {
            state.mergedPositions = mergedPositions;
        }
    },

    actions: {
        setPortfolios(context, { portfolios }) {
            context.commit('SET_PORTFOLIOS', { portfolios });
            portfolios.forEach(p => {
                p.stocks.forEach(s => {
                    const stock = new StockBaseInfo({ id: s.stockId, symbol: s.symbol, companyName: s.companyName, currency: s.currency, price: s.stockDateTimeSnapshot.price })
                    this.dispatch('addStockInfo', { stock }, { root: true })
                })
            })
        },

        setPosition(context, { positions }) {
            context.commit('SET_POSITIONS', { positions });
        },

        setMergedPositions(context, { mergedPositions }) {
            context.commit('SET_MERGED_POSITIONS', { mergedPositions });
        },

        createNewPortfolio(context, { name, description, currency }) {
            return new Promise((resolve, reject) => {
                addPortfolio({ portfolioName: name, portfolioDescription: description, currency }).then((response) => {
                    context.commit('ADD_PORTFOLIO', { portfolio: response.portfolio })
                    this.dispatch('setUsage', { usage: response.usage }, { root: true })
                    resolve();
                }).catch(error => { reject(error) })
            });
        },

        updateAllPortfolioInfos(context, { portfolios, transactions, stockObjectives }) {
            portfolios.forEach(p => {
                context.commit('UPDATE_PORTFOLIO_INFOS', {
                    id: p.id,
                    name: p.name,
                    description: p.description,
                    currency: p.currency,
                    statistics: p.statistics
                });
                context.commit('SET_TRANSACTIONS', { transactions });
                context.commit('SET_STOCK_OBJECTIVES', { stockObjectives });
            });
        },

        updatePortfolioSummary(context, { portfolioSummary }) {
            context.commit('SET_PORTFOLIO_SUMMARY', { portfolioSummary });
        },

        updateDataPackage(context, { dataPackage }) {
            context.commit('SET_DATA_PACKAGE', { dataPackage });
        },

        updatePortfolioInfos(context, { id, name, description, currency }) {
            return new Promise((resolve, reject) => {
                const data = { portfolioId: id, portfolioName: name, portfolioDescription: description, currency };
                updatePortfolio({ ...data }).then(() => {
                    context.commit('UPDATE_PORTFOLIO_INFOS', { id, name, description, currency });
                    resolve()
                }).catch(error => { reject(error) })
            })
        },

        addPortfolioStock(context, { portfolioId, stockId }) {
            return new Promise((resolve, reject) => {
                addPortfolioStock({ portfolioId, stockId }).then(stock => {
                    resolve()
                }).catch(error => { reject(error) })
            })
        },

        addPortfolioStockLot(context, { portfolioId, stockId, transactionType, transactionDate, stockQty, averageCostByShare, note }) {
            return new Promise((resolve, reject) => {
                addPortfolioStockLot({ portfolioId, stockId, transactionType, transactionDate, stockQty, averageCostByShare, note }).then(updatedPortfolio => {
                    context.commit('REPLACE_PORTFOLIO', { portfolio: updatedPortfolio })
                    resolve()
                }).catch(error => { reject(error) })
            })
        },

        deletePortfolio(context, { portfolioId }) {
            return new Promise((resolve, reject) => {
                deletePortfolio({ portfolioId }).then(() => {
                    context.commit('DELETE_PORTFOLIO', { portfolioId });
                    resolve()
                }).catch(error => { reject(error) })
            })
        },

        deletePortfolioStockLot(context, { portfolioId, stockId, lotId }) {
            return new Promise((resolve, reject) => {
                deletePortfolioStockLot({ portfolioId, stockId, lotId }).then(updatedPortfolio => {
                    context.commit('REPLACE_PORTFOLIO', { portfolio: updatedPortfolio })
                    resolve(updatedPortfolio)
                }).catch(error => { reject(error) })
            })
        },

        updatePortfolioStockLot(context, { portfolioId, stockId, lotId, transactionType, transactionDate, stockQty, averageCostByShare, note }) {
            return new Promise((resolve, reject) => {
                updatePortfolioStockLot({ portfolioId, stockId, lotId, transactionType, transactionDate, stockQty, averageCostByShare, note }).then(updatedPortfolio => {
                    context.commit('REPLACE_PORTFOLIO', { portfolio: updatedPortfolio })
                    resolve(updatedPortfolio)
                }).catch(error => { reject(error) })
            })
        },

        updatePortfolioAmountOfMoney(context, { portfolioId, amountOfMoney }) {
            return new Promise((resolve, reject) => {
                updatePortfolioAmountOfMoney({ portfolioId, amountOfMoney }).then(updatedPortfolio => {
                    context.commit('SET_PORTFOLIO_AMOUNT_IN_CASH', { portfolioId, amountOfMoney })
                    resolve()
                }).catch(error => { reject(error) })
            })
        },

        importInPortfolio(context, { portfolioId, fileInput }) {
            return new Promise((resolve, reject) => {
                importInPortfolio({ portfolioId, fileInput }).then(importPortfolioResult => {
                    context.commit('REPLACE_PORTFOLIO', { portfolio: importPortfolioResult.portfolio })
                    resolve(importPortfolioResult)
                }).catch(error => { reject(error) })
            })
        },

        movePortfolioStock(context, { fromPortfolioId, toPortfolioId, stockId }) {
            return new Promise((resolve, reject) => {
                movePortfolioStock({ fromPortfolioId, toPortfolioId, stockId }).then(updatedPortfolios => {
                    context.commit('REPLACE_PORTFOLIO', { portfolio: updatedPortfolios.fromPortfolio })
                    context.commit('REPLACE_PORTFOLIO', { portfolio: updatedPortfolios.toPortfolio })
                    resolve()
                }).catch(error => { reject(error) })
            })
        }
    },

    getters: {
        portfoliosLoaded(state) {
            return state.portfoliosLoaded;
        },
        portfolioList(state) {
            return state.portfolios
        },
        portfolioSummary(state) {
            return state.portfolioSummary
        },
        portfolioStock: (state) => ({ portfolioId, stockId }) => {
            const portfolio = state.portfolios.find(p => p.id === portfolioId)
            return portfolio ? portfolio.stocks.find(s => s.stockId === stockId) : undefined
        },
        userTransactions(state) {
            return state.transactions ? state.transactions : []
        },
        stockObjectives(state) {
            return state.stockObjectives ? state.stockObjectives : []
        },
        userPositions(state) { // old getter name kept for backward compatibility
            return state.positions ? state.positions : []
        },
        userMergedPositions(state) {
            return state.mergedPositions ? state.mergedPositions : []
        },
        aggregatedPortfolioStock(state) {
            return state.portfolioSummary.aggregatedPortfolioStock ? state.portfolioSummary.aggregatedPortfolioStock : []
        },
        dataPackage(state) {
            return state.dataPackage ? state.dataPackage : {}
        }
    }
}

export default portfoliosStore